// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow_arrow__xUIYG","arrowHighlighted":"Arrow_arrowHighlighted__gD1+F","arrowOpened":"Arrow_arrowOpened__PJo6S","arrowClosed":"Arrow_arrowClosed__vCN1H"};